import { extendTheme } from '@chakra-ui/react';

// ReDeuce Color Scheme from Design/Theme.md
const colors = {
  brand: {
    // Primary ReDeuce Yellow
    primary: '#FEEB15',
    primaryHover: '#F4DF13',
    primaryLight: '#FEF469',
    
    // Green variations
    green: {
      light: '#9DC650',
      medium: '#589432', 
      dark: '#264F42',
    },
    
    // Neutrals
    black: '#000000',
    gray: {
      50: '#F7F7F7',
      100: '#E1E1E1',
      200: '#CFCFCF',
      300: '#B1B1B1',
      400: '#9E9E9E',
      500: '#AAAAAA',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    }
  }
};

const fonts = {
  heading: `'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
  body: `'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
};

const theme = extendTheme({
  colors,
  fonts,
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'semibold',
        borderRadius: 'lg',
        transition: 'all 0.2s',
      },
      variants: {
        solid: {
          bg: 'brand.primary',
          color: 'black',
          _hover: {
            bg: 'brand.primaryHover',
            transform: 'translateY(-2px)',
            shadow: 'lg',
          },
        },
        outline: {
          borderColor: 'brand.primary',
          color: 'brand.primary',
          borderWidth: '2px',
          _hover: {
            bg: 'brand.primary',
            color: 'black',
            transform: 'translateY(-2px)',
          },
        },
        green: {
          bg: 'brand.green.medium',
          color: 'white',
          _hover: {
            bg: 'brand.green.dark',
            transform: 'translateY(-2px)',
            shadow: 'lg',
          },
        },
        greenOutline: {
          borderColor: 'brand.green.medium',
          color: 'brand.green.medium',
          borderWidth: '2px',
          _hover: {
            bg: 'brand.green.medium',
            color: 'white',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: 'bold',
      },
      variants: {
        brand: {
          color: 'brand.green.dark',
        },
      },
    },
    Box: {
      variants: {
        gradient: {
          bgGradient: 'linear(to-r, brand.green.light, brand.green.medium)',
        },
        primaryGradient: {
          bgGradient: 'linear(to-r, brand.primary, brand.primaryLight)',
        },
      },
    },
  },
  styles: {
    global: {
      body: {
        bg: 'white',
        color: 'black',
        lineHeight: '1.6',
      },
      '*': {
        boxSizing: 'border-box',
      },
    },
  },
});

export default theme; 